import {Component, EventEmitter, HostListener, OnInit, Output} from '@angular/core';

import {OptionService} from '../../shared/services/option/option.service';
import { SASEUNG_HELP_BBS_ID } from 'src/app/shared/defines/gukeo.const';
import { BBS_CATEGORY } from 'src/app/shared/defines/protocol';
import {SASEUNG_HELP_POPUP_PADDING} from "../../shared/defines/client.const";
import {
  Saseung3StatsService,
  SASEUNG3_STATS_FALLBACK_CHARACTER_TOTAL_COUNT,
  SASEUNG3_STATS_FALLBACK_TONE_MARKED_CHARACTER_COUNT,
} from '../../shared/services/saseung3/saseung3-stats.service';


@Component({
  selector: 'app-saseung3-help',
  templateUrl: './saseung3-help.component.html',
  styleUrls: ['./saseung3-help.component.scss']
})
export class Saseung3HelpComponent implements OnInit {
  @Output() closePopup: EventEmitter<any>;

  readonly BBS_CATEGORY = BBS_CATEGORY;
  readonly SASEUNG_HELP_BBS_ID = SASEUNG_HELP_BBS_ID;

  public calculatedHeight: number = window.innerHeight - SASEUNG_HELP_POPUP_PADDING;
  public characterTotalCount: number = SASEUNG3_STATS_FALLBACK_CHARACTER_TOTAL_COUNT;
  public toneMarkedCharacterCount: number = SASEUNG3_STATS_FALLBACK_TONE_MARKED_CHARACTER_COUNT;

  @HostListener('window:resize')
  onResize() {
    this.calculatedHeight = window.innerHeight - SASEUNG_HELP_POPUP_PADDING;
  }

  constructor(
    private optionService: OptionService,
    private saseung3StatsService: Saseung3StatsService,
  ) {
    this.closePopup = new EventEmitter<any>();
  }

  ngOnInit(): void {
    this.saseung3StatsService.getStats().subscribe({
      next: (stats) => {
        this.characterTotalCount = stats?.character_total_count == null
          ? SASEUNG3_STATS_FALLBACK_CHARACTER_TOTAL_COUNT
          : stats.character_total_count;
        this.toneMarkedCharacterCount = stats?.tone_marked_character_count == null
          ? SASEUNG3_STATS_FALLBACK_TONE_MARKED_CHARACTER_COUNT
          : stats.tone_marked_character_count;
      },
      error: (error) => {
        console.error('Saseung3HelpComponent::ngOnInit() stats load failed', error);
        this.characterTotalCount = SASEUNG3_STATS_FALLBACK_CHARACTER_TOTAL_COUNT;
        this.toneMarkedCharacterCount = SASEUNG3_STATS_FALLBACK_TONE_MARKED_CHARACTER_COUNT;
      },
    });
  }

  onClose(param: boolean = null): void {
    if (param !== null) {
      this.optionService.showSaseung = param;
    }
    this.closePopup.emit(param);
  }

}
